import React from 'react'

type ColorType = 'red' | 'yellow' | 'green' | 'gray'

interface ColorDotProps {
  colorType: ColorType
  onClick?: () => void
}

const ColorDot: React.FC<ColorDotProps> = ({ colorType, onClick }) => {
  const styles = {
    red: {
      background: '#FF7E7E',
      boxShadow:
        'inset 0px 1px 3px 1px rgba(0, 0, 0, 0.35), inset 0px -3px 2px 4px #E65353, inset 0px -5px 5px rgba(255, 255, 255, 0.7)',
    },
    yellow: {
      background: '#FDFF7E',
      boxShadow:
        'inset 0px 1px 3px 1px rgba(0, 0, 0, 0.35), inset 0px -3px 2px 4px #F3E11A, inset 0px -5px 5px rgba(255, 255, 255, 0.7)',
    },
    green: {
      background: '#A4FF7E',
      boxShadow:
        'inset 0px 1px 3px 1px rgba(0, 0, 0, 0.35), inset 0px -3px 2px 4px #48CA10, inset 0px -5px 5px rgba(255, 255, 255, 0.7)',
    },
    gray: {
      background: '#BABABA',
      boxShadow:
        'inset 0px 1px 3px 1px rgba(0, 0, 0, 0.35) inset, 0px -3px 2px 4px #D3D3D3 inset, 0px -5px 5px 0px rgba(255, 255, 255, 0.70)',
    },
  }

  return (
    <div
      className={`w-2.5 h-2.5 rounded-full ${onClick ? 'cursor-pointer' : ''}`}
      style={{
        background: styles[colorType].background,
        boxShadow: styles[colorType].boxShadow,
      }}
      onClick={onClick}
    ></div>
  )
}

export default ColorDot
